import type { ProductTourId } from "./types";

const DONE_PREFIX = "ew_product_tour_done_";

export function tourDoneKey(tourId: ProductTourId): string {
  return `${DONE_PREFIX}${tourId}`;
}

export function isTourDone(tourId: ProductTourId): boolean {
  try {
    return localStorage.getItem(tourDoneKey(tourId)) === "1";
  } catch {
    return false;
  }
}

export function markTourDone(tourId: ProductTourId): void {
  try {
    localStorage.setItem(tourDoneKey(tourId), "1");
  } catch {
    /* ignore quota / private mode */
  }
}
